import MinilogLogger from "./MinilogLogger";

export { MinilogLogger };

export default MinilogLogger;
